import './style.css';
import { Game } from './game/Game';

const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');
const uiRoot = document.querySelector<HTMLElement>('#ui-root');
if (!canvas || !uiRoot) throw new Error('Game host elements were not found.');

const game = new Game(canvas, uiRoot);

declare global {
  interface Window {
    __MOUTHBOUND_GAME__?: {
      getSnapshot: () => ReturnType<Game['getSnapshot']>;
      startLevel: (level: number) => Promise<void>;
      teleportPlayer?: (x: number, z: number) => void;
      runDirectionalTest?: (approach: 'front' | 'side' | 'rear') => Promise<void>;
    };
  }
}

window.__MOUTHBOUND_GAME__ = {
  getSnapshot: () => game.getSnapshot(),
  startLevel: (level) => game.begin(level),
};

if (new URLSearchParams(location.search).get('debug') === 'true') {
  window.__MOUTHBOUND_GAME__.teleportPlayer = (x, z) => game.debugTeleportPlayer(x, z);
  window.__MOUTHBOUND_GAME__.runDirectionalTest = (approach) => game.beginDirectionalTest(approach);
}
